import style from './list-cross.scss';
import $ from 'jquery';
import PerfectScrollbar from 'perfect-scrollbar';

const script = () => {
  const cssClass: string = 'ListCross';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    const container = elt.querySelector(`.${cssClass}-container`);
    if(container !== null) {
      const ps = new PerfectScrollbar(container, {
        suppressScrollY: true,
      });
    }
  }
};

export {
  style,
  script,
};
